import script from "./BookingPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingPreview.vue?vue&type=script&setup=true&lang=ts"

import "./BookingPreview.vue?vue&type=style&index=0&id=7e5dcdc4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e5dcdc4"]])

export default __exports__